import { takeLatest } from 'redux-saga/effects';
import {
  addCategoryImage,
  createCategory,
  deleteCategory,
  getCategories,
  updateCategory,
} from '../actions/categories';
import {
  addCategoryImageSaga,
  createCategorySaga,
  deleteCategorySaga,
  getCategoriesSaga,
  updateCategorySaga,
} from './categories';

import {
  createSupplier,
  deleteSupplier,
  getSuppliers,
  updateSupplier,
} from '../actions/suppliers';
import {
  createSupplierSaga,
  deleteSupplierSaga,
  getSuppliersSaga,
  updateSupplierSaga,
} from './suppliers';

import {
  createWarehouse,
  deleteWarehouse,
  getWarehouses,
  updateWarehouse,
} from '../actions/warehouses';
import {
  createWarehouseSaga,
  deleteWarehouseSaga,
  getWarehousesSaga,
  updateWarehouseSaga,
} from './warehouses';

import {
  addProductImage,
  createProduct,
  deleteProduct,
  deleteProductImage,
  getLatestProducts,
  getProductDetail,
  getProducts,
  getRelatedProducts,
  getTopDiscountProducts,
  getTopRatingProducts,
  updateProduct,
} from '../actions/products';
import {
  addProductImageSaga,
  createProductSaga,
  deleteProductImageSaga,
  deleteProductSaga,
  getLatestProductsSaga,
  getProductDetailSaga,
  getProductsSaga,
  getRelatedProductsSaga,
  getTopDiscountProductsSaga,
  getTopRatingProductsSaga,
  updateProductSaga,
} from './products';

import {
  getCustomers,
  updateAvatar,
  updateCustomer,
  updatePersonal,
} from '../actions/customers';
import {
  //createCustomerSaga,
  //deleteCustomerSaga,
  getCustomersSaga,
  updateAvatarSaga,
  updateCustomerSaga,
  updatePersonalSaga,
} from './customers';

import {
  createComment,
  deleteComment,
  getAllComments,
  getProductComments,
  updateComment,
} from '../actions/comments';
import {
  createCommentSaga,
  deleteCommentSaga,
  getAllCommentsSaga,
  getProductCommentsSaga,
  updateCommentSaga,
} from './comments';

import {
  cancelOrder,
  createOrder,
  getOrders,
  getUserOrders,
  refundStripe,
  updateOrder,
} from '../actions/orders';
import {
  cancelOrderSaga,
  createOrderSaga,
  getOrdersSaga,
  getUserOrdersSaga,
  refundStripeSaga,
  updateOrderSaga,
} from './orders';

import { getAdmins, updateAdmin } from '../actions/admins';
import { getAdminsSaga, updateAdminSaga } from './admins';

function* mySaga() {
  yield takeLatest(getCategories.getCategoriesRequest, getCategoriesSaga);
  yield takeLatest(createCategory.createCategoryRequest, createCategorySaga);
  yield takeLatest(updateCategory.updateCategoryRequest, updateCategorySaga);
  yield takeLatest(deleteCategory.deleteCategoryRequest, deleteCategorySaga);
  yield takeLatest(
    addCategoryImage.addCategoryImageRequest,
    addCategoryImageSaga
  );

  yield takeLatest(getSuppliers.getSuppliersRequest, getSuppliersSaga);
  yield takeLatest(createSupplier.createSupplierRequest, createSupplierSaga);
  yield takeLatest(updateSupplier.updateSupplierRequest, updateSupplierSaga);
  yield takeLatest(deleteSupplier.deleteSupplierRequest, deleteSupplierSaga);

  yield takeLatest(getWarehouses.getWarehousesRequest, getWarehousesSaga);
  yield takeLatest(createWarehouse.createWarehouseRequest, createWarehouseSaga);
  yield takeLatest(updateWarehouse.updateWarehouseRequest, updateWarehouseSaga);
  yield takeLatest(deleteWarehouse.deleteWarehouseRequest, deleteWarehouseSaga);

  yield takeLatest(getProducts.getProductsRequest, getProductsSaga);
  yield takeLatest(createProduct.createProductRequest, createProductSaga);
  yield takeLatest(updateProduct.updateProductRequest, updateProductSaga);
  yield takeLatest(deleteProduct.deleteProductRequest, deleteProductSaga);
  yield takeLatest(addProductImage.addProductImageRequest, addProductImageSaga);
  yield takeLatest(
    deleteProductImage.deleteProductImageRequest,
    deleteProductImageSaga
  );
  yield takeLatest(
    getLatestProducts.getLatestProductsRequest,
    getLatestProductsSaga
  );
  yield takeLatest(
    getTopRatingProducts.getTopRatingProductsRequest,
    getTopRatingProductsSaga
  );
  yield takeLatest(
    getTopDiscountProducts.getTopDiscountProductsRequest,
    getTopDiscountProductsSaga
  );
  yield takeLatest(
    getProductDetail.getProductDetailRequest,
    getProductDetailSaga
  );
  yield takeLatest(
    getRelatedProducts.getRelatedProductsRequest,
    getRelatedProductsSaga
  );
  yield takeLatest(getCustomers.getCustomersRequest, getCustomersSaga);
  //yield takeLatest(createCustomer.createCustomerRequest, createCustomerSaga);
  yield takeLatest(updateCustomer.updateCustomerRequest, updateCustomerSaga);
  //yield takeLatest(deleteCustomer.deleteCustomerRequest, deleteCustomerSaga);
  yield takeLatest(updatePersonal.updatePersonalRequest, updatePersonalSaga);
  yield takeLatest(updateAvatar.updateAvatarRequest, updateAvatarSaga);

  yield takeLatest(
    getProductComments.getProductCommentsRequest,
    getProductCommentsSaga
  );
  yield takeLatest(createComment.createCommentRequest, createCommentSaga);
  yield takeLatest(getAllComments.getAllCommentsRequest, getAllCommentsSaga);
  yield takeLatest(updateComment.updateCommentRequest, updateCommentSaga);
  yield takeLatest(deleteComment.deleteCommentRequest, deleteCommentSaga);

  yield takeLatest(createOrder.createOrderRequest, createOrderSaga);
  yield takeLatest(getOrders.getOrdersRequest, getOrdersSaga);
  yield takeLatest(updateOrder.updateOrderRequest, updateOrderSaga);
  yield takeLatest(getUserOrders.getUserOrdersRequest, getUserOrdersSaga);
  yield takeLatest(cancelOrder.cancelOrderRequest, cancelOrderSaga);
  yield takeLatest(refundStripe.refundStripeRequest, refundStripeSaga);

  yield takeLatest(getAdmins.getAdminsRequest, getAdminsSaga);
  yield takeLatest(updateAdmin.updateAdminRequest, updateAdminSaga);
}

export default mySaga;
